import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ReceiptDetail } from '../combined-orders/unified-order';

// Renders the customer details behind a receipt indicator. Shared by the grid
// tooltip and the detail popup so the two cannot drift apart.
@Component({
    selector: 'app-receipt-detail',
    templateUrl: './receipt-detail.component.html',
    styleUrls: ['./receipt-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class ReceiptDetailComponent {
    @Input({ required: true }) detail!: ReceiptDetail;
}
